import React, { Component } from "react";
import Cashier from "../components/Cashier";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  LogoutFunction,
  ServerSocket,
} from "../static.js";
import Loading from "../components/Loading";

export default class CashierPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resID: "",
      priceUnitValue: "",
      resNameValue: "",
      defaultLanguage: "",
      showCashier: false,
      descriptionValue: "",
      currentOrderDes: "",
      numberOfGuests: null,
      settlementType: 5,
      currentOrderMobile: null,
      currentOrderId: null,
      currentOrder: null,
      currentorderStationId: null,
      orderStationName: null,
      userFullName: "",
      loadingData: true,
    };
  }

  componentDidMount() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    // data = Object.assign(data, Authorization());

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let name = "";
          let des = "";
          result.info.forEach((element) => {
            if (element.languageId === 1) {
              name = element.name;
              des = element.descr;
            }
          });

          if (name === "") {
            result.info.forEach((element) => {
              if (element.languageId === result.result[0].defaultLanguage) {
                name = element.name;
                des = element.descr;
              }
            });
          }

          if (name === "") {
            result.info.forEach((element) => {
              if (name === "" && element.name !== "") {
                name = element.name;
                des = element.descr;
              }
            });
          }
          this.setState(
            {
              resID: result.result[0].id,
              priceUnitValue: result.result[0].rtlPriceTitle,
              resNameValue: name,
              descriptionValue: des,
              defaultLanguage: result.result[0].defaultLanguage,
              subscriptionType:
                result.result[0].subscriptionType === 1
                  ? 6
                  : result.result[0].subscriptionType,
              userFullName: result.result[0].userFullName,
            },
            () => {
              this.setState({ loadingData: false });
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (!this.state.loadingData)
      return (
        <Cashier
          resID={this.state.resID}
          priceUnitValue={this.state.priceUnitValue}
          businessCode={this.props.match.params.id}
          languageId={this.state.defaultLanguage}
          backToDashboard={() => {
            this.props.history.push(
              "/Restaurants/" + this.props.match.params.id
            );
          }}
          currentorderStationId={this.state.currentorderStationId}
          currentOrder={this.state.currentOrder}
          currentOrderDes={this.state.currentOrderDes}
          numberOfGuests={this.state.numberOfGuests}
          settlementType={this.state.settlementType}
          currentOrderMobile={this.state.currentOrderMobile}
          currentOrderId={this.state.currentOrderId}
          orderStationName={this.state.orderStationName}
          userFullName={this.state.userFullName}
          updateProps={(type, newValue) => {
            switch (type) {
              case "currentorderStationId": {
                this.setState({ currentorderStationId: newValue });
                break;
              }
              case "currentOrderDes": {
                this.setState({ currentOrderDes: newValue });
                break;
              }
              case "numberOfGuests": {
                this.setState({ numberOfGuests: newValue });
                break;
              }
              case "settlementType": {
                this.setState({ settlementType: newValue });
                break;
              }
              case "currentOrder": {
                this.setState({ currentOrder: newValue });
                break;
              }
              case "currentOrderId": {
                this.setState({ currentOrderId: newValue });
                break;
              }
              default:
                break;
            }
          }}
        />
      );
    else return <Loading />;
  }
}
